import React, { FC } from "react";

import { Title } from "..";
import style from "./styles.module.css";

type Props = {
  data: [{ description: string; fullName: string; id: number; image: string }];
  // teacher: {
  //     description: string;
  //     fullName: string;
  //     id: number;
  //     image: string;
  // };
};
const Teachers: FC<Props> = ({ data }) => {
  return (
    <div
      className={`h-auto rounded bg-white px-3 py-5 shadow-md transition-all md:p-5`}
      style={{
        contain: "content",
      }}
    >
      <div className={`relative transition-all`} style={{ contain: "content" }}>
        <Title
          type="DOT"
          title="اساتید دوره"
          wrapperClass="text-black-550 mb-5"
        />
        {data?.map((a) => (
          <div
            key={JSON.stringify(a?.id)}
            className={`${style.commentWrapper} relative grid w-full grid-cols-[_1fr,_3fr] pb-10 after:absolute after:bottom-0 after:mx-auto after:mb-2 after:h-px after:w-full after:content-[''] first:py-7 last:after:w-0`}
          >
            <div
              style={{
                background:
                  "linear-gradient(238.69deg, rgba(54, 100, 147, 0.88) 3.2%, rgba(4, 128, 212, 0.88) 44.48%, rgba(39, 177, 187, 0.88) 83.25%)",
              }}
              className="relative ml-5 h-24 w-24 rounded md:ml-14 md:h-36 md:w-36"
            >
              <div
                style={{
                  background: "rgba(5, 119, 175, 0.5)",
                }}
                className="absolute -bottom-2 -left-2 h-24 w-24 rounded md:-bottom-5 md:-left-5 md:h-36 md:w-36"
              >
                <img
                  loading="lazy"
                  src={a.image ?? "images/person.png"}
                  alt="استاد"
                />
              </div>
            </div>
            <div className="flex flex-col justify-center">
              <h3 className="mb-5 text-sm md:text-base">{a?.fullName}</h3>
              <ul className="list-inside space-y-3">
                <li className="list-no-marker">
                  <span className="text-justify text-xs md:text-base">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: a?.description,
                      }}
                      className={style.customList}
                    />
                  </span>
                </li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Teachers;
